export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "total_number_providers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proveedores"])},
          "provider": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proveedor"])},
          "expired_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vencido"])},
          "days": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["En ", _interpolate(_named("days")), " días"])},
          "download_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar reporte"])}
        }
      },
      "en": {
        "labels": {
          "total_number_providers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Providers"])},
          "provider": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Provider"])},
          "expired_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Expired"])},
          "days": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["days"])},
          "download_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download report"])}
        }
      }
    }
  })
}